import React from 'react'
import {FlatButton, FontIcon} from 'material-ui'
import {Link} from 'react-router-dom'
import PropTypes from 'prop-types';


const PackageDetailTitle = ({title}) => (
    <div style={{'float': 'left'}}>
        <FlatButton labelStyle={{fontSize: '2em'}} containerElement={<Link to={"/"}/>} label={title} icon={
            <FontIcon style={{fontSize: '2em'}} className="material-icons">arrow_back</FontIcon>}/>
    </div>
)

PackageDetailTitle.propTypes = {
    title: PropTypes.string.isRequired
}

export default PackageDetailTitle;


// WEBPACK FOOTER //
// ./src/components/packages/PackageDetailTitle.js